import {
  SkillModel,
  SkillStatus,
} from "../../api/models/RecitationSkillsModel";
import { SkillsType } from "./SkillsListParser";
import recitationSkills from "./recitationSkills.json";
import i18n from "../../i18n";
export class SkillsService {
  private __skills: SkillModel[];

  constructor(APICompletedHashedPaths: string[]) {
    const skills = JSON.parse(JSON.stringify(recitationSkills)) as SkillsType[];
    this.__skills = this.toSkillModel(skills);
    this.setCompletedSkills(APICompletedHashedPaths);
  }

  private toSkillModel = (skills: SkillsType[]): SkillModel[] => {
    return skills.map((skill: any) => {
      if (skill.subSkills) {
        return new SkillModel(
          skill[`${i18n.language}`],
          skill.ar,
          this.toSkillModel(skill.subSkills)
        );
      }
      return new SkillModel(skill[`${i18n.language}`], skill.ar);
    });
  };

  private flattenSkills = (skills: SkillModel[]): SkillModel[] => {
    return skills.reduce((acc, skill) => {
      if (skill.isLeaf) {
        return [...acc, skill];
      }
      return [...acc, skill, ...this.flattenSkills(skill.subSkills)];
    }, [] as SkillModel[]);
  };

  get skills() {
    return this.__skills.slice();
  }

  getSkillByHashedPath(hashedPath: string) {
    return this.flattenSkills(this.skills).find(
      (skill) => skill.hashedPath === hashedPath
    );
  }

  get completedSkills() {
    const completedSkills = this.skills
      .flatMap((skill) => skill.leafSkills)
      .filter((skill) => skill.isCompleted);

    const completedHashedPaths = completedSkills.map(
      (skill) => skill.hashedPath
    );
    return completedHashedPaths;
  }

  setCompletedSkills(hashedPaths: string[]) {
    hashedPaths.forEach((hashedPath) => {
      const skill = this.getSkillByHashedPath(hashedPath);
      if (skill) {
        skill.setCompleted();
      }
    });
  }

  setSkillStatus(hashedPath: string, status: SkillStatus) {
    const skill = this.getSkillByHashedPath(hashedPath);
    if (skill) {
      skill.setStatus(status);
    }
  }

  toggleSkillStatus(hashedPath: string) {
    const skill = this.getSkillByHashedPath(hashedPath);
    if (skill) {
      if (skill.isCompleted) {
        skill.setNotStarted();
      } else {
        skill.setCompleted();
      }
    }
  }

  searchSkills(searchTerm: string) {
    const skills = this.flattenSkills(this.skills);
    return skills.filter((skill) => skill.name.includes(searchTerm));
  }
}
